import script from "./CotizadorManual.vue?vue&type=script&setup=true&lang=js"
export * from "./CotizadorManual.vue?vue&type=script&setup=true&lang=js"

import "./CotizadorManual.vue?vue&type=style&index=0&id=c27ab41a&lang=css"

const __exports__ = script;

export default __exports__